module.exports = __webpack_public_path__ + "static/media/icono_gluten.0e6b0bf1.png";